import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { Attachment, Meta } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: Attachment[];
  meta: Meta;
}

export default function useGetAttachments(params: { [key: string]: any } = {}) {
  const { accountId, accountUserId } = useAdminParams();
  const { state } = useProvider();
  const args = state;

  return useQuery<Result, Error>({
    queryKey: [c.ATTACHMENTS, params],
    queryFn: async () => {
      const api = new Api(args);

      if (params?.keyword) {
        params.keyword = params.keyword.replace('+', '');
      }

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/attachments',
            params,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/attachments`,
            params,
          },
        }),
      );

      return data;
    },
    enabled: !!params?.referenceId && !!params?.source,
  });
}
